import { type PropertiesConfigInputVisualEffectModel } from '@blaze-shared/elements-domain';

import { PropsBuilder } from '../__base/props-builder';

export class IFramePropsBuilder extends PropsBuilder<'iframe'> {
  override setVisualEffect = (
    visualEffect: PropertiesConfigInputVisualEffectModel | undefined,
  ): this => {
    this.patchProps({ style: { background: { visualEffect } } });
    return this;
  };
}
